module.exports = __webpack_public_path__ + "img/no-phone.09997741.svg";